<template>
  <v-card>
    <v-card-title>
        Messaging with Advanced Filters
        <v-spacer></v-spacer>
        <v-icon @click="$emit('close')">mdi-close</v-icon>
    </v-card-title>
    <v-row>
       <v-col cols="12">
           <v-row>
               <v-col cols="12" md="12">
                   <DriverMessagingFilterBox :driver-groups="driverGroups" :ride-types="rideTypes" :councils="councils" :query="query"></DriverMessagingFilterBox>
               </v-col>
           </v-row>
           <v-row>
               <v-col cols="12">
                   <v-divider class="my-3"></v-divider>
               </v-col>
           </v-row>
           <v-row>
               <v-col cols="12" md="12">
                   <v-textarea
                       outlined
                       v-model="query.message"
                       maxlength="500"
                       label="Message"
                       placeholder="Enter your message"
                   ></v-textarea>
                   <p style="color: red">{{ error }}</p>
               </v-col>
               <v-col md="12">
                   <label>Channel </label>
                   <v-btn-toggle
                       v-model="query.channel"
                       tile
                       color="deep-purple accent-3"
                       group
                   >
                       <v-btn value="push">
                           Push Notification
                       </v-btn>
                       
                       <v-btn value="sms">
                           Text Message
                       </v-btn>
                   </v-btn-toggle>
               </v-col>
               <v-col md="12" class="text-center">
                   <v-divider class="my-3"></v-divider>
               </v-col>
               <v-col md="12" class="text-center">
                   <v-btn tile color="primary" class="mx-2" @click="getFilteredDriversList(true)">Send Message</v-btn>
                   <v-btn tile color="blue darken-2" class="white--text mx-2" @click="getFilteredDriversList(false)">Show Drivers</v-btn>
               </v-col>
           </v-row>
           <v-row>
               <v-col md="12">
                   <v-divider class="my-3"></v-divider>
               </v-col>
           </v-row>
           <v-row>
               <template v-for="driver in drivers">
                   <v-col md="3" :key="driver.id">
                       <DriverDetailsChatCard @initChat='initChat' :ride-types="rideTypes" class="ma-2" :driver="driver"></DriverDetailsChatCard>
                   </v-col>
               </template>
           </v-row>
           <v-row v-if="drivers.length">
               <v-col md="12">
                   <template>
                       <div class="text-center">
                           <v-pagination
                               v-model="offset"
                               :length="totalPages"
                               @input="getFilteredDriversList(false)"
                           ></v-pagination>
                       </div>
                   </template>
               </v-col>
           </v-row>
       </v-col>
    </v-row>
  </v-card>
</template>

<script>
import qs from "qs";
import axios from "axios";
import DriverMessagingFilterBox from '@/components/messaging/DriverMessagingFilterBox.vue'
import DriverDetailsChatCard from '@/components/messaging/DriverDetailsChatCard.vue'
axios.defaults.withCredentials = true;

export default {
  name: "AdvancedMessageFiltersDialog",
    components: {DriverDetailsChatCard, DriverMessagingFilterBox},
  model: {
    prop: "time",
    event: "input",
  },
  props: {
    onlineOnly: Boolean,
    group: Object,
    twilioChannels: Array
  },
  data() {
    return {
      message: "",
      error: "",
      offset: 0,
      count: 25,
      drivers: [],
      driversLength: 0,
      rideTypes: [],
      driverGroups: [],
      councils: [],
        query: {
          channel: 'push',
          lockedOut: false,
          councils: [],
          postCodes: [],
          rideTypes: [],
          lastLoginTime: '',
          driverGroups: [],
          message: ''
      }
    };
  },
  created() {
    this.getCouncilsAndRideTypes()
    this.getDriverGroups()
  },
    computed: {
      totalPages () {
          return Math.ceil(this.driversLength / this.count)
      }
    },
    methods: {
      initChat (driver) {
        let channel = this.twilioChannels.find(channel => {
            return channel.sid == driver.chat_channel
        })
          if (channel) {
              this.$store.commit('messaging/setSelectedDriverChannel', channel)
          }
      },
        getDriverGroups: async function() {
            try {
                var url = `${this.$store.state.apiUrl}/driver_group/all`;
                
                let response = await axios.get(url, {
                    params: {}
                });
                
                this.driverGroups = response.data;
            } catch (e) {
                console.log(e);
            }
        },
            getCouncilsAndRideTypes: async function () {
          try {
              let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
              let response = await axios.get(url, {
                  params: {},
              });
              this.rideTypes = response.data.ride_types;
              this.councils = response.data.councils;
          } catch (error) {
              console.log(
                  "Failed to get information required to create taxi " + error
              );
          }
      },
      sent: function () {
      this.$emit("sent");
    },
    sendMessage: async function () {
      this.$emit("sent", this.message);
    },
    async getFilteredDriversList(sendMessage = false) {
          this.drivers.length = 0;
        if (sendMessage && !this.query.message) {
            this.error = 'Please type message here.'
            return;
        } else {
            this.error = ''
        }
          try {
              var url = `${this.$store.state.apiUrl}/chat/applyFilters?`;

              url +=`count=${this.count}`
              url +=`&offset=${this.offset}`
              
              if (!this.query.lockedOut) {
                  this.query.lockedOut = false
              }
              url += `&locked_out=${this.query.lockedOut}`
              
              if (this.query.councils.length) {
                  url+=`&councils=${this.query.councils}`
              }
              if (this.query.postCodes.length) {
                  url+=`&post_codes=${this.query.postCodes}`
              }
              if (this.query.rideTypes.length) {
                  url+=`&ride_types=${this.query.rideTypes}`
              }
              if (this.query.driverGroups.length) {
                  url+=`&driver_groups=${this.query.driverGroups}`
              }
              
              if (sendMessage) {
                  url+=`&send_message=${sendMessage}`
              } else {
                  url+=`&show_drivers=${true}`
              }
              
              
              if (!this.query.channel) {
                  this.query.channel = 'push'
              }
              
              url+=`&channel=${this.query.channel}`
              url+=`&message=${this.query.message}`
              let response = await axios.get(url, {
                  params: {},
              });
              
              if (response.data.error == "no_error") {
                  console.log(response.data)
                  this.drivers = response.data.drivers
                  this.driversLength = response.data.drivers_length
                  if (sendMessage) {
                      this.$snackbar.show("Messages sent to drivers")
                  }
              } else {
                  alert("Error sending to all drivers");
              }
              
              this.loading = false;
          } catch (error) {
            console.log(error)
              alert("Error sending to all drivers");
              this.loading = false;
          }
      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
